import React, { useEffect } from "react";
import { connect } from "react-redux";
import { generateSDEAnalysis } from "../../../../store/modules/qualityOfEarnings/actions";
import Matrix from "./MatrixComponent";
import YearBar from "../YearBar";
import Subtitle from "../Subtitle";
import Item from "./Item";

function SDEAnalysis({
  currentCompanySDEAnalysis,
  dispatchGenerateSDEAnalysis,
}) {
  // Mounted
  useEffect(() => {
    dispatchGenerateSDEAnalysis();
  }, []);

  return (
    <div>
      <h2 className="sectionHead">Discretionary Earnings Report</h2>

      <div className="pb-10">
        <Subtitle title="Yearly EBITDA as Defined" />
        <YearBar data={currentCompanySDEAnalysis?.yearsFormatted} />
        
        {currentCompanySDEAnalysis.independence === "MANUAL" ?
          <>
            <Item name="Sales Revenue" data={currentCompanySDEAnalysis?.totalSalesRevenue} bold={true} manuality={true} />
            <Item name="Net Income" manuality={true} data={currentCompanySDEAnalysis?.manualNetIncome} />
            <Item name="Interest" manuality={true} data={currentCompanySDEAnalysis?.manualInterest} />
            <Item name="Taxes" manuality={true} data={currentCompanySDEAnalysis?.manualTaxes} />
            <Item name="Depreciation" manuality={true} data={currentCompanySDEAnalysis?.manualDepreciation} />
            <Item name="Amortization" manuality={true} data={currentCompanySDEAnalysis?.manualAmortization} />
          </>
          :
          <Item name="Sales Revenue" data={currentCompanySDEAnalysis?.totalSalesRevenue} bold={true} />
        }
        <Item name="EBITDA as Defined" data={currentCompanySDEAnalysis?.EBITDA} bold={true} />
      </div>

      {currentCompanySDEAnalysis &&
        <div>
          <Matrix labelTitle="Management" />
          <Matrix labelTitle="Diligence" />
          <Matrix labelTitle="Pro Forma" />
          <Matrix labelTitle="Owner Salary" />
          <div className="pb-10">
            <Subtitle title="Discretionary Earnings Report Summary" />
            <YearBar data={currentCompanySDEAnalysis?.yearsFormatted} />
            <Item name="Yearly EBITDA as Defined" data={currentCompanySDEAnalysis?.EBITDA} bold={true} />
            <Item name="(+) Total Management Adjusted" data={currentCompanySDEAnalysis["totalManagementAdj"]} />
            <Item name="EBITDA Management Adjusted" data={currentCompanySDEAnalysis["EBITDAManagementAdj"]} bold={true} />
            <Item name="(+) Total Diligence Adjusted" data={currentCompanySDEAnalysis["totalDiligenceAdj"]} />
            <Item name="EBITDA Diligence Adjusted" data={currentCompanySDEAnalysis["EBITDADiligenceAdj"]} bold={true} />
            <Item name="(+) Total Pro Forma Adjusted" data={currentCompanySDEAnalysis["totalProFormaAdj"]} />
            <Item name="EBITDA Pro Forma Adjusted" data={currentCompanySDEAnalysis["EBITDAProFormaAdj"]} bold={true} />
            <Item name="(+) Owner Salary and Payroll Taxes" data={currentCompanySDEAnalysis["totalOwnerSalaryandPayrollTaxes"]} />
            <Item name="Discretionary Owner Earnings" data={currentCompanySDEAnalysis["EBITDAOwnerSalaryAdj"]} bold={true} />
          </div>
        </div>
      }
    </div>
  );
}

const mapStateToProps = (state) => ({
  currentCompanySDEAnalysis: state.qualityOfEarnings.currentCompanySDEAnalysis,
});

const mapDispatchToProps = (dispatch) => ({
  async dispatchGenerateSDEAnalysis() {
    await dispatch(generateSDEAnalysis());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SDEAnalysis);
